import { LoaderFunctionArgs } from "react-router-dom";
import { BasketDto } from "./types/basketDto";
import { basketService } from "@/services/basket/basketService";

export async function basketLoader({}: LoaderFunctionArgs): Promise<BasketDto> {
  try {
    const response = await basketService.getBasket();
    return response as BasketDto;
  } catch (error) {
    throw new Error(error instanceof Error ? error.message : "Unknown error");
  }
}
